<template>
    <section class="g-container || o-band">
        <div class="o-container">

            <app-intro class="u-d-sm-flex align-items-sm-center justify-content-sm-between">
                <div>
                    <h3 class="c-intro__title">Vestigingen</h3>
                </div>

                <div class="g-cols:2/auto || g-gap:1-xs">
                    <div class="c-btn-group c-btn-group--stacked">
                        <app-button to="/admin/storec-mobiel" class="c-btn c-btn--square c-btn--white">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12">
                                <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2">
                                    <path d="M1 1h14"/>
                                    <path d="M1 6h14"/>
                                    <path d="M1 11h14"/>
                                </g>
                            </svg>
                        </app-button>

                        <app-button to="#0" class="c-btn c-btn--square c-btn--info">
                            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
                                <g transform="translate(-1401 -118)" fill="currentColor">
                                    <rect width="6" height="6" rx="1" transform="translate(1401 118)"/>
                                    <rect width="6" height="6" rx="1" transform="translate(1408 118)"/>
                                    <rect width="6" height="6" rx="1" transform="translate(1401 125)"/>
                                    <rect width="6" height="6" rx="1" transform="translate(1408 125)"/>
                                </g>
                            </svg>
                        </app-button>
                    </div>

                    <app-button to="/admin/storec-mobiel/add" class="c-btn c-btn--info">
                        Gebruiker toevoegen

                        <svg xmlns="http://www.w3.org/2000/svg" width="14.875" height="14.875" viewBox="0 0 14.875 14.875">
                            <g fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2">
                                <path d="M1 7.438h12.875"/>
                                <path d="M7.437 1v12.875"/>
                            </g>
                        </svg>
                    </app-button>
                </div>
            </app-intro>

            <loading v-bind:nodes="locations">Bezig met laden van de vestigingen...</loading>

            <transition-group class="g-cols:2>sm g-cols:3>md g-cols:2>lg g-cols:3>xl || g-gap:1-xs g-gap:1-sm>sm" name="fade" tag="section" v-if="locations.length">

                <router-link :to="`/admin/storec-mobiel/${location.VestigingID}/location`" class="c-node" v-for="location in locations" :key="'location-' + location.VestigingID">
                    <h4 class="c-node__title">{{ location.Vestigingsnaam }}</h4>
                    <ul class="c-node__list">
                        <li>{{ location.Vestigingsadres }}</li>
                        <li>{{ location.Contactpersoon }}</li>
                    </ul>
                </router-link>

            </transition-group>

            <div v-else>
                <p>Er zijn nog geen vestigingen aangemaakt. Maak er <router-link to="/admin/locations/add">hier</router-link> een aan.</p>
            </div>

        </div>
    </section>
</template>

<script>
    import { mapState } from 'vuex';
    import AppButton from '../../components/app/AppButton.vue';
    import AppIntro from '../../components/app/AppIntro.vue';
    import Loading from '../../components/Loading.vue';

    export default {
        components: { AppButton, AppIntro, Loading },
        computed: {
            ...mapState({
                locations: (state) => state.location.list,
            }),
        },
        created () {
            this.$store.dispatch('location/list');
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/_essentials.scss";

    .table {
        @include media-breakpoint-down(xsl) {
            grid-template-columns: rem(150) 1fr;
        }

        @include media-breakpoint-only(sm) {
            grid-template-columns: rem(200) 1fr;
        }

        &__tr {
            @include media-breakpoint-up(md) {
                grid-template-columns: repeat(4, 1fr);
            }
        }
    }
</style>
